const messages = {
  word: {
    show: "Show",
    artwork: "Artwork",
    fair: "Fair",
  },
};

export default messages;
